import { createFileRoute } from '@tanstack/react-router';

import VoiceSalesCampaignDetailPage from '../../views/dashboard-voice-sales/CampaignDetailPage';

export const Route = createFileRoute('/dashboard/voice-sales/campaigns_/$campaignUuid')({
  component: VoiceSalesCampaignDetailPage,
});
